import { DataSource, Label, Layout, Panel, SearchButton, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPeriodicThreadDumps extends Layout {
    labelP: Label;
    panelAnalysis: Panel;
    panelThreadDumpList: Panel;
    searchbuttonSearchbutton1: SearchButton;
    sourcePeriodicThreadDump: DataSource;
    tableThreadDumps: Table;
    textboxD: Textbox;
    textboxE: Textbox;
}
